import { makeStyles } from '@mui/styles'; 
import { red, green } from '@mui/material/colors';

const drawerWidth = 240;
// For use where we don't want 'px' on the end: MUI changed theme spacing definition to include 'px'
const themeSpacing = 8;

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		'& .MuiAppBar-root': {
			transition: 'background-color 0.5s',
			[theme.breakpoints.up('sm')]: {
				transition: 'width 1s, background-color 1s', 
				zIndex: 1201,
				'& .MuiToolbar-root': {
					maxWidth: 800 + themeSpacing * 6 + drawerWidth,
					transition: 'max-width 1s',
				}
			},
			'& h6': {
				flexGrow: 1,
				
			},
			'& a': {
				color: theme.palette.common.white,
				textDecoration: 'none'
			}, 
		},
		'& .MuiFormHelperText-root': {
			fontSize: '0.9em',
			lineHeight: '1.2em'
		},
		'& .MuiSnackbarContent-root': {
			flexWrap: 'nowrap',
		},
		'& .MuiTableCell-root': {
			fontSize: 15,
		},
		[theme.breakpoints.down('smd')]: {
			'& .MuiStepper-horizontal': {
				paddingLeft: 0,
				paddingRight: 0
			},
		},
	},
	contextualAppBar: {
		backgroundColor: theme.palette.primary.dark +' !important',
		transition: 'background-color 0.5s', 
		[theme.breakpoints.up('sm')]: {
			width: `calc(100% - ${drawerWidth}px) !important`,
			zIndex: 1200 +' !important',
			marginLeft: drawerWidth +' !important',
			'& .MuiToolbar-root': {
				maxWidth: (800 + themeSpacing * 6) +'px !important',
			},
			transition: 'width 1s, z-index 3s, background-color 1s !important', 
		},
	},
	bottomAppBar: {
		bottom: 0,
		top: 'auto !important',
		backgroundColor: '#fff !important',
		'& .MuiToolbar-root': {
			justifyContent: 'flex-end !important',
		},
		'& a, button': {
			color: theme.palette.primary.dark + ' !important',
		}
	},
	embeddedAppBar: {
		bottom: 0,
		top: 'auto !important',
		backgroundColor: '#fff !important',
		borderTop: '1px solid ' + theme.palette.primary.dark,
		'& .MuiToolbar-root': {
			justifyContent: 'space-between',
			maxWidth: '100% !important',
		},
		'& .MuiToolbar-root .MuiButton-root:first-child': {
			fontWeight: 'bold',
		},
		'& a, button, h6, p': {
			color: theme.palette.primary.dark + ' !important',
		},
		
	},
	appBarButtons: {
		display: 'flex',
		alignItems: 'center',
		'& > .MuiButton-sizeSmall, a': {
			marginLeft: theme.spacing(1)
		},
		'& .MuiButton-label': {
			whiteSpace: 'nowrap',
		}
	},
	menuButton: {
		[theme.breakpoints.up('sm')]: {
			display: 'none !important',
		},
	},
	drawer: {
		[theme.breakpoints.up('sm')]: {
			width: drawerWidth,
			flexShrink: 0,
		},
	},
	toolbar: theme.mixins.toolbar,
	drawerPaper: {
		width: drawerWidth,
	},
	embeddedDrawer: {
		flexShrink: 0,

	},
	embeddedDrawerPaper: {
		[theme.breakpoints.down('sm')]: {
			height: '100% !important',
		},
		'& > div': {
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			'-webkit-overflow-scrolling': 'touch',
		},
		'& ul': {
			display: 'flex',
			flexWrap: 'wrap',
			[theme.breakpoints.up('sm')]: {
				'& a': {
					maxWidth: '320px',
				},
			},
			'& a:focus': {
				outline: 'none',
			}
		},
	},
	embeddedDrawerTop: {
		flex: '0 0 auto',
		padding: theme.spacing(2) + ' ' + theme.spacing(3),
		borderBottom: '1px solid #eee',
	},
	embeddedDrawerMiddle: {
		flex: '1 1 auto',
		overflowY: 'auto',
	},
	embeddedDrawerBottom: {
		flex: '0 0 auto',
		padding: theme.spacing(1) + ' ' + theme.spacing(2),
		borderTop: '1px solid #eee',
		textAlign: 'right',
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(3),
		},
	},
	embeddedContent: {
		flexGrow: 1,
		paddingBottom: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			paddingBottom: theme.spacing(3),
		},
	},
	innerContent: {
		whiteSpace: "pre-line",
		'& a, a:visited': {
			color: theme.palette.primary.dark,
			wordWrap: 'break-word',
			overflowWrap: 'break-word',
			wordBreak: 'break-all',
		},
		'& a:hover': {
			color: theme.palette.primary.light
		},
		maxWidth: '100%',
		[theme.breakpoints.up('sm')]: {
			maxWidth: '800px',
		},
		border: window.$umas4m_config.embedded ? '1px solid ' + theme.palette.primary.dark : null,
	},
	otherContent: {
		whiteSpace: "pre-line",
		'& a, a:visited': {
			color: theme.palette.primary.dark,
			wordWrap: 'break-word',
			overflowWrap: 'break-word',
			wordBreak: 'break-all',
		},
		'& a:hover': {
			color: theme.palette.primary.light
		},

	},
	noBreakAll: {
		wordBreak: 'break-word !important',
	},
	condensedList: {
		'& ul, ol': {
			paddingLeft: theme.spacing(3),
		},
		[theme.breakpoints.down('smd')]: {
			'& ul, ol': {
				paddingLeft: theme.spacing(5),
			},
		},
	},
	page: {
		padding: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(3),
		},
		marginBottom: theme.spacing(2),
	},
	paginator: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		[theme.breakpoints.up('md')]: {
			paddingLeft: theme.spacing(3),
			paddingRight: theme.spacing(3),
		},
		[theme.breakpoints.up('smd')]: {
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1),
		},
		marginBottom: theme.spacing(2),
		marginTop: theme.spacing(2),
		'& button:first-child': {
			marginLeft: '-3px'
		}
	},
	relative: {
		position: 'relative',
	},
	nav: {
		[theme.breakpoints.up('sm')]: {
			'& a': {
				paddingLeft: theme.spacing(3),
				paddingRight: theme.spacing(3)
			}
		},
		'& a:hover': {
			backgroundColor: theme.palette.secondary.main,
			textDecoration: 'none',
		},
		'& a.active': {
			backgroundColor: theme.palette.secondary.light
		}
	},
	navicon: {
		'& svg': {
			color: theme.palette.primary.main
		}
	},
	naviconText: {
		'& span': {
			fontWeight: 500
		},
	},
	u3aLogo: {
		marginTop: theme.spacing(0.5),
		maxWidth: '100%',
		maxHeight: '200px',
	},
	sectionTitle: {
		marginTop: theme.spacing(3),
		paddingTop: theme.spacing(2),
		borderTop: '1px solid #ddd',
		//marginBottom: theme.spacing(2)
	},
	contentList: {
		'& .MuiAvatar-colorDefault': {
			backgroundColor: theme.palette.tertiary.grey,
		},
		'& .MuiListItemText-primary': {
			fontWeight: 500
		},
		[theme.breakpoints.down('sm')]: {
			'& li': {
				paddingLeft: theme.spacing(1),
				paddingRight: theme.spacing(1),
			}
		}
	},
	form: {
		'& .MuiGrid-container': {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1)
		},
		'& div.MuiDivider-root': {
			width: `calc(100% - ${themeSpacing * 4}px)`,
			borderColor: theme.palette.secondary.light,
			marginBottom: theme.spacing(1),
			marginTop: theme.spacing(2),
		},
		'& #field-suburb': {
			position: 'relative'
		},
		'& #suburb_popper': {
			width: `calc(100% - ${themeSpacing * 2}px)`,
			zIndex: 100,
			'& ul': {
				maxHeight: '300px',
				overflowY: 'scroll',
			}
		},
	},
	formButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		'& button': {
			marginTop: theme.spacing(2),
			marginLeft: theme.spacing(1),
		}
	},
	formPPButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingTop: theme.spacing(2),
		'& button': {
			marginLeft: theme.spacing(1),
		}
	},
	formLeftButtons: {
		display: 'flex',
		justifyContent: 'flex-start',
		'& button': {
			marginTop: theme.spacing(2),
			marginRight: theme.spacing(1),
		}
	},
	actionButton: {
		display: 'flex',
		justifyContent: 'center',
		padding: theme.spacing(2),
		'& a': {
			textDecoration: 'none'
		}
	},
	datePicker: {
		'& .MuiIconButton-root': {
			color: theme.palette.primary.main
		}
	},
	snackMessage: {
		display: 'flex',
		alignItems: 'center',
		'& svg': {
			marginRight: theme.spacing(1)
		}
	},
	errorSnack: {
		color: red[700]
	},
	successSnack: {
		color: green[700]
	},
	homeCards: {
		maxWidth: '600px',
	},
	homeCardsEmbedded: {
		maxWidth: '600px',
		paddingTop: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			paddingTop: theme.spacing(3),
		},
	},
	homeCard: {
		'& .MuiSvgIcon-root': {
			width: '30%',
			height: '100%',
			padding: theme.spacing(1.5),
			backgroundColor: theme.palette.primary.light, 
			display: 'block',
			position: 'absolute'
		},
		[theme.breakpoints.up('sm')]: {
			height: '100%',
			display: 'flex',
			'& .MuiSvgIcon-root': {
				position: 'relative',
				padding: theme.spacing(1),
				width: '100%',
				height: 'auto',
				minHeight: '200px',
				marginRight: '0',
			},
		},
		[theme.breakpoints.up('md')]: {
			'& .MuiSvgIcon-root': {
				minHeight: '250px',
			},
		},
		'& a, a:hover': {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'flex-start',
			minHeight: '100px',
			textDecoration: 'none',
			overflow: 'auto',
			color: theme.palette.primary.dark,
			'& .MuiCardContent-root': {
				color: theme.palette.text.primary,
				marginLeft: '30%'
			},
			[theme.breakpoints.up('sm')]: {
				flexDirection: 'column',
				'& .MuiCardContent-root': {
					marginLeft: '0'
				},
			},
		},
		'& a:focus': {
			outline: 'none',
		}
	},
	settingsDialog: {
		'& .MuiFormLabel-root': {
			fontWeight: 'bold',
		}
	},
	settingsSelect: {
		width: '100%',
		marginBottom: theme.spacing(2),
		'& label + div': {
			marginTop: theme.spacing(1)
		}
	},
	settingsTextField: {
		'& label + div': {
			marginTop: theme.spacing(1)
		},
	},
	settingsDivider: {
		width: theme.spacing(0.25),
		backgroundColor: '#eee',
		marginTop: 0,
		marginBottom: 0,
		marginLeft: theme.spacing(0.5),
		marginRight: theme.spacing(0.5),
		[theme.breakpoints.up('smd')]: {
			marginLeft: theme.spacing(1.5),
		}
	},
	boxAlignTop: {
		paddingTop: theme.spacing(2),
		'& .MuiFormControlLabel-root': {
			alignItems: 'normal',
			marginBottom: theme.spacing(0.5),
		},
		'& label > span:first-child': {
			paddingTop: theme.spacing(0.25),
			paddingBottom: theme.spacing(1),
			alignItems: 'flex-start',
		}
	},
	coursesGroup: {
		padding: theme.spacing(2),
		[theme.breakpoints.up('md')]: {
			padding: theme.spacing(3),
		},
		marginTop: theme.spacing(2),
		marginBottom: 0,
		'& .MuiGrid-container': {
			paddingRight: theme.spacing(4.5),
			paddingTop: theme.spacing(1),
		},
		'& .MuiGrid-item': {
			paddingBottom: 0
		}
	},
	accordion: {
		'& .MuiAccordionSummary-content': {
			display: 'block',
			'& p:first-child, h3': {
				display: 'flex',
				alignItems: 'center', 
				'& > div': {
					fontWeight: 'normal',
					marginRight: theme.spacing(2),
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					fontSize: '.9em',
				},
			},
		},
		'& .MuiAccordionDetails-root': {
			borderTop: '1px solid #ddd',
			paddingTop: theme.spacing(2),
		},			
		'& .MuiAccordionActions-root > p': {
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1),
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
		},
		'& .MuiAccordionSummary-expandIconWrapper': {
			padding: theme.spacing(1.5),
		},
		[theme.breakpoints.up('md')]: {
			'& .MuiAccordionSummary-content': {
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				'& p': {
					flex: 1,
					paddingRight: theme.spacing(1),
					textAlign: 'right',
				},
				'& p:first-child, h3': {
					paddingLeft: theme.spacing(1),
					paddingRight: theme.spacing(1),
					textAlign: 'left',
				},
				'& p:last-child': {
					paddingRight: 0
				}
			},
			'& .MuiAccordionDetails-root': {
				paddingLeft: theme.spacing(3),
				paddingRight: theme.spacing(3)
			}
		},
		[theme.breakpoints.down('md')] : {
			'& .MuiAccordionActions-root > p': {
				padding: theme.spacing(1),
			}
		},
		[theme.breakpoints.down('md')] : {
			'& .MuiAccordionSummary-root': {
				alignItems: 'flex-start',
				'& p:first-child, h3': {
					marginBottom: theme.spacing(0.5),
				},
			},
		},
		[theme.breakpoints.down('sm')] : {
			'& .MuiAccordionSummary-root': {
				paddingLeft: theme.spacing(2),
				paddingRight: theme.spacing(2)
			},
			'& .MuiAccordionDetails-root': {
				paddingLeft: theme.spacing(2),
				paddingRight: theme.spacing(2)
			},

		}
	},
	courseHeader: {
		[theme.breakpoints.up('md')]: {
			'& > div': {
				flex: 1, 
			},
			'& > div:first-child' : {
				flex: 1.5
			},
			'& > div:nth-child(2)': {
				paddingRight: 0
			}
		},
	},
	course: {
		'& .MuiAccordionSummary-content': {
			'& p:first-child, h3': {
				flexDirection: 'row-reverse',
				justifyContent: 'space-between',  
				'& > .MuiChip-root': {
					fontWeight: 'normal',
					lineHeight: 1,
					marginLeft: theme.spacing(1),
				},
				'& > div': {
					fontWeight: 'normal',
					marginRight: theme.spacing(2),
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					fontSize: '.9em',
				},
			},
		},
		[theme.breakpoints.up('md')]: {
			'& .MuiAccordionSummary-content': {
				'& p:first-child, h3': {
					flex: 1.5, 
				},
			},
		},
	},
	chipC: {
		backgroundColor: theme.palette.secondary.verypale + ' !important',
	},
	chipE: {
		backgroundColor: theme.palette.primary.verypale + ' !important',
	},
	chipW: {
		backgroundColor: theme.palette.primary.verypale + ' !important',
	},
	chipD: {
		backgroundColor: theme.palette.tertiary.pale + ' !important',
	},
	chipClosed: {
		backgroundColor: theme.palette.tertiary.pale + ' !important',
	},
	chipNew: {
		backgroundColor: theme.palette.primary.lightpale + ' !important',
		'& .MuiChip-icon': {
			color: theme.palette.primary.light + ' !important',
		}
	},
	avatarC: {
		backgroundColor: theme.palette.secondary.light + ' !important',
		color: theme.palette.common.black + ' !important',
	},
	avatarE: {
		backgroundColor: theme.palette.primary.main + ' !important',
		color: theme.palette.common.white + ' !important',
	},
	avatarW: {
		backgroundColor: theme.palette.primary.main + ' !important',
		color: theme.palette.common.white + ' !important',
	},
	avatarD: {
		backgroundColor: theme.palette.tertiary.grey + ' !important',
		color: theme.palette.common.white + ' !important',
	},
	avatarClosed: {
		color: theme.palette.tertiary.grey + ' !important',
		backgroundColor: '#fff !important',
		border: '2px solid ' + theme.palette.tertiary.grey,
	},
	avatarNew: {
		color: theme.palette.primary.light + ' !important',
		backgroundColor: '#fff !important',
		border: '2px solid ' + theme.palette.primary.light,
	},
	buttonProgress: {
		position: 'absolute',
	},
	bannerGrid: {
		'& > .MuiGrid-item': {
			width: 'auto',
		},
		'& .MuiGrid-justify-xs-flex-end': {
			flex: 1,
		},
	},
	secondaryText: {
		color: theme.palette.tertiary.grey,
	},
	cartTable: {
		'& td:last-child, th:last-child': {
			textAlign: 'right',
		},
		'& tr:last-child td' : {
			fontWeight: 'bold'
		},
	},
	flexCartTable: {
		'& .MuiTableRow-root': {
			borderBottom: '1px solid rgb(230, 230, 230)',
		}
	},
	flexTable: {
		'& .MuiTableRow-root': {
			display: 'flex',
			flexDirection: 'column',
		},
		'& .MuiTableRow-root:last-child': {
			flexDirection: 'row',
			justifyContent: 'flex-end'
		},
		'& .MuiTableCell-root': {
			borderBottomWidth: 0
		},
		'& .MuiTableCell-root:first-child': {
			order: 1
		},
		'& .MuiTableCell-root:last-child': {
			order: 2
		},
		'& .MuiTableRow-root:last-child .MuiTableCell-root:first-child': {
			order: 0
		}
	},
	waitlistItem: {
		'& .MuiTableCell-root:last-child': {
			color: theme.palette.text.disabled,
			textDecoration: 'line-through '+theme.palette.text.disabled,
		}
	},
	invoiceDue: {
		'& .MuiAccordionSummary-content p': {
			color: theme.palette.error.main,
		}
	},
	invoicesHeader: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		paddingRight: theme.spacing(0.5) + ' !important',
	},
	invoiceDetail: {
		whiteSpace: "pre-line",
		flexDirection: 'column',
		'& table': {
			marginTop: theme.spacing(3),
			marginBottom: theme.spacing(3),
			'& td, th': {
				borderBottom: 'none',
			},
			'& thead': {
				backgroundColor: theme.palette.secondary.light,
			},
			'& tbody': {
				borderTop: '2px solid ' + theme.palette.primary.main,
				borderBottom: '2px solid ' + theme.palette.primary.main,
			},
			'& tr': {
				borderBottom: '1px solid ' + theme.palette.primary.main,
			},
			'& tbody tr:last-child': {
				backgroundColor: theme.palette.secondary.verypale,
			}
		}
	},
	invoiceHeader: {
		'& .MuiGrid-item > .MuiGrid-item:first-child': {
			order: 1
		}
	},
	PayPalButton: {
		marginLeft: theme.spacing(2) + ' !important',
		height: '38px',
	},
	footerRow: {
		flexDirection: 'row !important',
		justifyContent: 'flex-end',
		'& .MuiTableCell-root:first-child': {
			order: '0 !important'
		}
	},
	thickTop: {
		borderTop: '2px solid ' + theme.palette.primary.main,
	},
	marginBelow: {
		marginBottom: theme.spacing(2) + ' !important',
	},
	enrolmentsTable: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(4),
		'& [data-column="detail"] div': {
			display: 'flex',
			flexDirection: 'column',
			'& button': {
				marginTop: theme.spacing(0.75),
				marginBottom: theme.spacing(0.75),
				maxWidth: '180px'
			}
		}
	},
	enrolmentsFlexTable: {
		'& .MuiTableRow-root': {
			display: 'flex',
			flexDirection: 'column',
			borderBottom: '2px solid ' + theme.palette.primary.main,
			backgroundColor: theme.palette.secondary.extremelypale,
			marginBottom: theme.spacing(1),
			paddingTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
			'& td, th': {
				borderBottom: 'none',
			},
		},
	},
	enrolmentsFlexFooter: {	
		'& .MuiTableRow-footer td > .MuiGrid-root': {
			marginBottom: theme.spacing(1)
		}
	},
	deletedItem: {
		'& .MuiTableCell-root': {
			color: theme.palette.text.disabled,
			textDecoration: 'line-through '+theme.palette.text.disabled,
		},
		'& .MuiTableCell-root:last-child': {
			textDecoration: 'none'
		}
	},
	dueItem: {
		'& [data-column="invoice_no"] .MuiButton-outlinedPrimary': {
			color: theme.palette.error.main,
			border: '1px solid rgba(229,115,115,0.7)',
		},
		'& [data-column="invoice_no"] .MuiButton-outlinedPrimary:hover': {
			border: '1px solid '+theme.palette.error.main,
			backgroundColor: 'rgba(229,115,115,0.04)',
		}
	},
	shopCardGrid: {
		marginTop: theme.spacing(1) + ' !important',
		'& .MuiCard-root': {
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
		},
		'& .MuiCardContent-root': {
			backgroundColor: theme.palette.secondary.verypale,
			borderBottom: '2px solid ' + theme.palette.primary.main,
			flex: 1,
		},
		'& .MuiCardActions-root': {
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
			paddingRight: theme.spacing(2),
			paddingLeft: theme.spacing(2),
			'& p': {
				flex: 1,
			},
			'& a, a:hover': {
				textDecoration: 'none',
			},
		},
		'& .MuiCardActions-root > *': {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
	},
	footer: {
		color: theme.palette.tertiary.grey,
		marginTop: theme.spacing(3),
		maxWidth: '100%',
		marginBottom: window.$umas4m_config.embedded ? null : theme.spacing(7),
		[theme.breakpoints.up('sm')]: {
			maxWidth: '800px',
		},
		'& p': {
			marginTop: theme.spacing(2),
			fontSize: '0.8em',
		},
	},
	gutterTop: {
		marginTop: '0.35em',
	},

}));

export default useStyles;